import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { Row, Col } from 'react-bootstrap';

import { InfoMessage, PopOutChart } from 'sharedComponents';
import useChartConfig, { chartPlugins } from './useChartConfig';

import './style.scss';
import { EnableUniqueScaling, PopOutButton, ResetZoomButton, withLeftButtonGroup, withPopOutRow, withRightButtonGroup } from 'sharedComponents/Chart/headers';
import useChartResize from 'sharedHooks/useChartResize';

const TrendSignalChartComponent = (props) => {

    const {
        model,
        actions,
    } = props;

    const containerRef = useRef();
    const chartRef = useRef();

    useChartResize(containerRef, chartRef);

    const zoomIn = (from, to) => {
        actions.zoomInToSelectedTrendKpiData(model.selectedTrendsData, from, to, props.asset);
    };
    const resetZoom = () => {
        actions.reloadAllSelectedTrendKpiData(model.selectedTrendsData, props.asset);
    };
    const eventTrend = false;
    const graphOptions = useChartConfig(model.selectedTrendsData, model.event, model.showUtcDates, actions.removeSelectedKpiLegend, model.trendKPIsList);

    const CustomHeader = withPopOutRow([
        withLeftButtonGroup([EnableUniqueScaling]),
        withRightButtonGroup([ResetZoomButton, PopOutButton])]);

    return (
        <Row className={`trend-signal-chart-area ${model.selectedTrendsData.length > 0 ? 'signal-selected' : ''}`}>
            <Col md={12}>
                <div ref={containerRef}>
                    <PopOutChart
                        hasKpi={model.selectedTrendsData.length !== 0}
                        data={eventTrend}
                        renderNoKpi={() => <InfoMessage
                            title='ABB.Powertrain.Frontend.chartNoKPIsSelected'
                            text='ABB.Powertrain.Frontend.chartNoKPIsSelectedUserGuide' />}
                        enableUniqueScaling={model.enableUniqueScaling}
                        zoomInServer={zoomIn}
                        resetServerZoom={resetZoom}
                        isZoomed={model.isZoomed}
                        setIsZoomed={actions.setIsZoomed}
                        options={graphOptions}
                        modules={chartPlugins}
                        loadingStatus={model.trendDataLoadingStatus}
                        container='op-trend-chart'
                        mainChartHeader={CustomHeader}
                        chartRef={chartRef}
                        isTrendSignal={true}
                    />
                </div>
            </Col>
        </Row>
    );
};

TrendSignalChartComponent.propTypes = {
    model: PropTypes.shape({
        selectedTrendsData: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string, // ID of the trend data
                name: PropTypes.string, // Name of the trend data
            })
        ), // Array of selected trend data
        event: PropTypes.object, // Event details (can be null or an object)
        showUtcDates: PropTypes.bool, // Whether to show UTC dates
        enableUniqueScaling: PropTypes.bool, // Whether unique scaling is enabled
        isZoomed: PropTypes.bool, // Whether the chart is zoomed
        trendDataLoadingStatus: PropTypes.string, // Loading status of the trend data
        trendKPIsList: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string, // KPI ID
                label: PropTypes.string, // KPI label
            })
        ), // List of trend KPIs
    }), // Model containing state data
    actions: PropTypes.shape({
        zoomInToSelectedTrendKpiData: PropTypes.func, // Function to zoom in on selected trend KPI data
        reloadAllSelectedTrendKpiData: PropTypes.func, // Function to reload all selected trend KPI data
        removeSelectedKpiLegend: PropTypes.func, // Function to remove a selected KPI legend
        setIsZoomed: PropTypes.func, // Function to set the zoom state
    }), // Actions object containing functions
    asset: PropTypes.shape({
        id: PropTypes.string, // Asset ID
        name: PropTypes.string, // Asset name
    }), // Asset details
};

export default TrendSignalChartComponent;
